<template>
    <dl class="myo_search_list">
        <dt>{{ i18n.myoffice.productName }}</dt>
        <dd><input type="text" name="down_name" id="down_name" v-bind="down_name"  :placeholder="i18n.myoffice.productName"></dd>
    </dl>

</template>

<script>
export default {
    name: "productNameForm",
    data: () => ({
        i18n: window.i18n,
    }),
    props : {
        down_name : String,
    }
}
</script>

<style scoped>

</style>
